import React from 'react';
import { ShieldAlertIcon, LockIcon, UserXIcon } from 'lucide-react';
interface SensitivityTagProps {
  kind: 'privileged' | 'sealed' | 'juvenile';
}
const config = {
  privileged: {
    label: 'Privileged',
    icon: ShieldAlertIcon,
    classes: 'bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-300 border-purple-200 dark:border-purple-800'
  },
  sealed: {
    label: 'Sealed',
    icon: LockIcon,
    classes: 'bg-rose-50 dark:bg-rose-900/20 text-rose-700 dark:text-rose-300 border-rose-200 dark:border-rose-800'
  },
  juvenile: {
    label: 'Juvenile',
    icon: UserXIcon,
    classes: 'bg-orange-50 dark:bg-orange-900/20 text-orange-700 dark:text-orange-300 border-orange-200 dark:border-orange-800'
  }
};
export function SensitivityTag({
  kind
}: SensitivityTagProps) {
  const {
    label,
    icon: Icon,
    classes
  } = config[kind];
  return <span title={`${label} — export-controlled`} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold ${classes}`} data-id="element-181">
      <Icon size={10} data-id="element-182" />
      {label}
    </span>;
}